import { takeEvery, put, call, throttle } from "redux-saga/effects"
import { request, API } from "../utils"
import config from "../config/env"

// 获取个人数据
const getMyStatusRequest = () =>
  request({
    method: "get",
    url: API.getMyStatus + `?activityCode=${config.ACTIVITY_CODE}`,
  })

function* getMyStatus() {
  const { data } = yield call(getMyStatusRequest)
  yield put({ type: "PUT_MY_STATUS", payload: data })
}
//开宝箱
const getMyTreasureRequest = () =>
  request({
    method: "get",
    url: API.openTreasure + `?activityCode=${config.ACTIVITY_CODE}`,
  })
function* openTreasure() {
  const { data } = yield call(getMyTreasureRequest)
  yield put({ type: "PUT_TREASURE", payload: data })
  //开宝箱后，查看我的状态
  yield call(getMyStatus)
}

//获取奖品列表
const getPrizeListRequest = () =>
  request({
    method: "get",
    url: API.getStorage + `?activityCode=${config.ACTIVITY_CODE}`,
  })
function* getPrizeList() {
  const { data } = yield call(getPrizeListRequest)
  yield put({ type: "PUT_PRIZE_LIST", payload: data })
}

//秒杀
const grabPrizeRequest = (giftCode) =>
  request({
    method: "get",
    url:
      API.grabTreasure +
      `?activityCode=${config.ACTIVITY_CODE}&giftCode=${giftCode}`,
  })

function* grabPrize(action) {
  const { data } = yield call(grabPrizeRequest, action.giftCode)
  yield put({ type: "PUT_MY_GRABBED_GIFT", payload: data })

  // 返回秒抢结果后，请求当前奖品状态
  yield call(getPrizeList)
}

// 我的奖品
const getMyPrizeRequest = () =>
  request({
    method: "get",
    url: API.getMyGift + `?activityCode=${config.ACTIVITY_CODE}`,
  })

function* getMyPrize() {
  const { data } = yield call(getMyPrizeRequest)
  yield put({ type: "PUT_MY_PRIZE", payload: data })
}

// 给别人助力
const boostTheHelperRequest = (shareId) =>
  request({
    method: "get",
    url: API.helpAddPoints + `?shareId=${shareId}`,
  })

function* boostTheHelper(action) {
  yield call(boostTheHelperRequest, action.shareId)
}

export default function* rootSaga() {
  yield takeEvery("GET_MY_STATUS", getMyStatus)
  yield takeEvery("OPEN_TREASURE", openTreasure)
  yield takeEvery("GET_PRIZE_LIST", getPrizeList)
  yield throttle(1000, "GRAB_PRIZE", grabPrize)
  yield takeEvery("GET_MY_PRIZE", getMyPrize)
  yield takeEvery("BOOST_THE_HELPER", boostTheHelper)
}
